import { AnimatePresence, motion } from 'framer-motion';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';

import { MainLayout } from './MainLayout';

import { Contact } from '@/features/contact';
import { Home } from '@/features/home';
import { PrivacyPolicy } from '@/features/legal';
import { Portfolio } from '@/features/portfolio';
import { PortfolioDetails } from '@/features/portfolio/routes/PortfolioDetails';
import { Services } from '@/features/services';
import { WhoWeAre } from '@/features/whoWeAre';

const publicRoutes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'services',
        element: <Services />,
      },
      {
        path: 'who-we-are',
        element: <WhoWeAre />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      {
        path: 'portfolio',
        element: <Portfolio />,
      },
      {
        path: 'portfolio/:key',
        element: <PortfolioDetails />,
      },

      { path: '*', element: <Navigate to="." /> },
    ],
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />,
  },
];

export const AppRoutes = () => {
  const element = useRoutes(publicRoutes);
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, scale: 1 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {element}
      </motion.div>
    </AnimatePresence>
  );
};
